import { SideMenuItem } from '@/modules/layout/composables/useSideMenu/SideMenuItem'

export const sideMenuConfig = [
  new SideMenuItem({
    name: 'menu.general',
    routeName: 'config',
    key: 'config',
    icon: 'settings',
    readyForMobile: true,
    access: ['locationManagerAccess'],
    products: ['bookings', 'shop', 'delivery', 'pos'],
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.products',
    routeName: 'lastProducts',
    key: 'lastProducts',
    icon: 'floorplan-plus',
    readyForMobile: true,
    access: ['locationManagerAccess'],
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.subscription',
    routeName: 'subscription',
    key: 'subscription',
    icon: 'star',
    readyForMobile: true,
    access: ['locationManagerAccess'],
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.locations',
    routeName: 'locations',
    key: 'locations',
    access: ['organizationManagementAccess'],
    icon: 'store',
    readyForMobile: true,
    locationType: ['organization', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.legal-entities',
    routeName: 'legalEntitiesList',
    key: 'legalEntitiesList',
    icon: 'building',
    readyForMobile: true,
    access: ['organizationManagementAccess'],
    locationType: ['organization', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.brands',
    routeName: 'brands',
    key: 'brands',
    icon: 'brand',
    readyForMobile: true,
    access: ['organizationManagementAccess'],
    products: ['shop', 'delivery', 'pos'],
    locationType: ['organization', 'singleLocation']
  }),

  new SideMenuItem({
    name: 'menu.users',
    routeName: 'users',
    key: 'users',
    icon: 'user',
    readyForMobile: true,
    access: ['organizationManagementAccess'],
    products: ['shop', 'delivery', 'pos'],
    locationType: ['organization', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.device-management',
    routeName: 'devices',
    key: 'devices',
    icon: 'mobile',
    readyForMobile: true,
    access: ['locationManagerAccess'],
    products: ['shop', 'delivery', 'pos'],
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.printers',
    routeName: 'printers',
    key: 'printers',
    icon: 'printer',
    readyForMobile: true,
    access: ['locationManagerAccess'],
    products: ['shop', 'delivery', 'pos'],
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.integrations',
    routeName: 'integrations',
    key: 'integrations',
    icon: 'double-arrow-inside',
    readyForMobile: true,
    access: ['locationManagerAccess'],
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.online-shop',
    icon: 'lucide/shopping-basket',
    key: 'storefront',
    readyForMobile: true,
    featureFlag: 'storefront',
    collapsible: true,
    locationType: ['location', 'singleLocation'],
    submenu: [
      new SideMenuItem({
        name: 'menu.online-shop-settings',
        routeName: 'storefrontSettings',
        key: 'storefrontSettings',
        featureFlag: 'storefront',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.online-shop-checkout',
        routeName: 'storefrontCheckout',
        key: 'storefrontCheckout',
        featureFlag: 'storefront',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.online-shop-reminders',
        routeName: 'storefrontReminders',
        key: 'storefrontReminders',
        featureFlag: 'storefront',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      })
    ]
  }),
  new SideMenuItem({
    name: 'menu.shop',
    routeName: 'organizationShop',
    key: 'organizationShop',
    icon: 'cart',
    access: ['organizationManagementAccess'],
    products: ['shop'],
    locationType: ['organization']
  }),
  new SideMenuItem({
    name: 'menu.delivery',
    icon: 'bike',
    key: 'deliveryMain',
    readyForMobile: true,
    access: ['locationManagerAccess'],
    products: ['delivery', 'shop'],
    locationType: ['location', 'singleLocation'],
    submenu: [
      new SideMenuItem({
        name: 'menu.general',
        key: 'delivery',
        routeName: 'delivery',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.orders-limit',
        routeName: 'ordersLimit',
        key: 'ordersLimit',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      })
    ]
  }),
  new SideMenuItem({
    name: 'menu.floorplan',
    routeName: 'floorPlan',
    key: 'floorPlan',
    icon: 'floorplan',
    readyForMobile: true,
    access: ['locationManagerAccess'],
    products: ['bookings', 'pos'],
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.schedules',
    routeName: 'schedules',
    key: 'schedules',
    icon: 'time',
    access: ['locationManagerAccess'],
    products: ['bookings', 'shop', 'delivery'],
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.shop',
    key: 'locationShop',
    icon: 'store',
    routeName: 'locationShop',
    readyForMobile: true,
    access: ['locationManagerAccess'],
    products: ['shop'],
    collapsible: false,
    locationType: ['location']
  }),
  new SideMenuItem({
    name: 'menu.shop',
    key: 'shop',
    icon: 'store',
    readyForMobile: true,
    access: ['locationManagerAccess'],
    products: ['shop'],
    collapsible: false,
    locationType: ['singleLocation'],
    submenu: [
      new SideMenuItem({
        name: 'menu.scripts',
        routeName: 'organizationShop',
        key: 'organizationShop',
        readyForMobile: true,
        access: ['organizationManagementAccess'],
        locationType: ['singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.config',
        routeName: 'locationShop',
        key: 'locationShop',
        readyForMobile: true,
        access: ['locationManagerAccess'],
        locationType: ['location', 'singleLocation']
      })
    ]
  }),
  new SideMenuItem({
    name: 'menu.qr',
    key: 'QR',
    icon: 'qr-code',
    readyForMobile: true,
    routeName: 'QR',
    products: ['qr'],
    access: ['locationManagerAccess'],
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.employees',
    key: 'employees',
    icon: 'people',
    readyForMobile: true,
    routeName: 'employees',
    locationType: ['location', 'singleLocation']
  }),
  new SideMenuItem({
    name: 'menu.pos',
    icon: 'screen',
    access: ['locationManagerAccess'],
    products: ['pos'],
    key: 'pos',
    readyForMobile: true,
    collapsible: false,
    locationType: ['location', 'singleLocation'],
    submenu: [
      new SideMenuItem({
        name: 'menu.config',
        key: 'posConfig',
        readyForMobile: true,
        routeName: 'posConfig',
        locationType: ['location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'menu.fastpos',
        routeName: 'fastModeConfig',
        key: 'fastModeConfig',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      })
    ]
  }),
  new SideMenuItem({
    name: 'menu.bookings',
    routeName: 'organizationBookings',
    key: 'organizationBookings',
    icon: 'calendar',
    access: ['organizationManagementAccess'],
    products: ['bookings'],
    readyForMobile: true,
    locationType: ['organization']
  }),
  new SideMenuItem({
    name: 'menu.bookings',
    icon: 'calendar',
    key: 'bookings',
    products: ['bookings'],
    access: ['locationManagerAccess'],
    collapsible: false,
    readyForMobile: true,
    locationType: ['location', 'singleLocation'],
    submenu: [
      new SideMenuItem({
        name: 'bookings.availability',
        key: 'bookingsAvailability',
        routeName: 'bookingsAvailability',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'bookings.policies.title',
        key: 'bookingsPolicy',
        routeName: 'bookingsPolicy',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'bookings.shifts.title',
        key: 'bookingsShifts',
        routeName: 'bookingsShifts',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      }),
      new SideMenuItem({
        name: 'bookings.communications.title',
        key: 'bookingsCommunications',
        routeName: 'bookingsCommunications',
        readyForMobile: true,
        locationType: ['location', 'singleLocation']
      })
    ]
  })
]
